import {useCallback} from 'react';

interface UseAiWriterPersistOnSelectParams<T> {
  persist?: (item: T, prompt: string) => Promise<void>;
  onSelected: (item: T) => void;
}

export function useAiWriterPersistOnSelect<T>({persist, onSelected}: UseAiWriterPersistOnSelectParams<T>): (item: T, prompt: string) => void {
  return useCallback(
    (item: T, prompt: string): void => {
      if (persist) {
        void persist(item, prompt).catch((e: unknown) => {
          console.error('AI writer persist-on-select failed:', e);
        });
      }
      onSelected(item);
    },
    [persist, onSelected]
  );
}
